var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationLifestyle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3EE9E5",
    d: "M60.285 92.87l-14.873-9.765v-28.28c0-.99-.798-1.794-1.782-1.794s-1.782.803-1.782 1.794V83.13l-14.872 9.766 33.309-.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093F68",
    d: "M60.285 93.481H26.952a.613.613 0 01-.327-1.123L41.217 82.8V54.825a2.396 2.396 0 012.388-2.405 2.396 2.396 0 012.388 2.405V82.8l14.612 9.56a.613.613 0 01-.327 1.122h.006zm-31.26-1.22h29.217L45.08 83.622a.612.612 0 01-.273-.512V54.825a1.18 1.18 0 00-1.176-1.184c-.649 0-1.175.53-1.175 1.184V83.13a.612.612 0 01-.273.513L29.024 92.26z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.667,
    cy: 19.044,
    fill: "#080C20",
    rx: 11.024,
    ry: 11.103
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093F68",
    d: "M11.667 30.758c-4.704 0-8.945-2.854-10.745-7.231a11.775 11.775 0 012.52-12.765 11.57 11.57 0 0112.675-2.54c4.346 1.813 7.18 6.085 7.18 10.822-.007 6.466-5.21 11.707-11.63 11.714zm0-22.2c-4.215 0-8.014 2.557-9.626 6.478a10.547 10.547 0 002.261 11.436c2.98 3 7.463 3.896 11.356 2.27s6.43-5.453 6.427-9.698C22.082 13.25 17.42 8.552 11.667 8.545v.013z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080C20",
    d: "M43.63 58.121L7.903 16.285h71.455z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093F68",
    d: "M43.636 58.732a.604.604 0 01-.46-.214L7.448 16.682a.614.614 0 01-.09-.653.606.606 0 01.551-.354h71.449c.236 0 .452.137.551.354.1.217.064.472-.09.653L44.09 58.518a.604.604 0 01-.455.214zM9.224 16.896L43.63 57.18l34.406-40.285H9.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3EE9E5",
    d: "M16.503 26.351l27.127 31.77 27.128-31.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093F68",
    d: "M43.636 58.732a.604.604 0 01-.46-.214l-27.128-31.77a.614.614 0 01-.09-.654.606.606 0 01.551-.354h54.255c.236 0 .452.138.551.354.1.217.064.472-.09.653L44.096 58.518a.604.604 0 01-.46.214zM17.83 26.992l25.806 30.19L69.448 26.96l-51.618.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093F68",
    d: "M44.648 53.525a.61.61 0 01-.51-.94L76.807.305a.606.606 0 01.84-.192c.284.18.37.559.19.845l-32.672 52.28a.606.606 0 01-.516.287z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.085,
    cy: 7.947,
    fill: "#080C20",
    rx: 6.273,
    ry: 6.318
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093F68",
    d: "M73.085 14.875c-3.803.004-6.888-3.098-6.891-6.928-.003-3.83 3.076-6.936 6.879-6.94 3.802-.003 6.887 3.099 6.89 6.928 0 3.828-3.077 6.933-6.878 6.94zm0-12.641a5.672 5.672 0 00-5.247 3.526 5.743 5.743 0 001.232 6.23 5.643 5.643 0 006.187 1.233 5.714 5.714 0 003.495-5.288c-.01-3.147-2.543-5.694-5.667-5.701z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093F68",
    d: "M69.624 7.605a.602.602 0 01-.182 0 .611.611 0 01-.4-.763c.862-2.607 3.62-4.056 6.237-3.277A.626.626 0 0175 4.785C71.297 3.9 70.242 7.1 70.2 7.227a.606.606 0 01-.576.378zM40.68 35.177a.645.645 0 01-.26-.055l-10.461-5.06a.572.572 0 01-.31-.342.614.614 0 010-.47l5.019-10.535a.604.604 0 01.806-.287l10.46 5.054c.3.145.428.508.285.812l-5.006 10.54a.608.608 0 01-.345.312.55.55 0 01-.188.03zm-9.655-5.952l9.37 4.53 4.497-9.437-9.37-4.53-4.497 9.437zm7.94 19.277a.606.606 0 01-.564-.385l-3.176-8.112a.614.614 0 01.34-.794l8.072-3.198a.602.602 0 01.788.342l3.182 8.112a.612.612 0 01-.345.787l-8.049 3.205a.602.602 0 01-.248.043zm-2.394-8.375l2.733 6.97 6.927-2.752-2.733-6.97-6.927 2.752z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLifestyle);
export default __webpack_public_path__ + "static/media/illustration-lifestyle.91a086882568d740383f98ef195a58a8.svg";
export { ForwardRef as ReactComponent };